<div class="row mt-5">
  <div class="col-sm-12 col-md-6 mx-auto">
    <mat-card>
      <mat-card-content class="text-center">
        <p>¡Documento gestionado con éxito!</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>